"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
exports.__esModule = true;
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _createIcon = _interopRequireDefault(require("../Icon/createIcon"));
/* eslint-disable */
var _default = (0, _createIcon.default)( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M3.304 4.8h17.392c.72 0 1.304.584 1.304 1.304v11.74c0 .72-.584 1.304-1.305 1.304h-8.56l-5.54 3.835a.435.435 0 0 1-.682-.357v-3.478H3.304A1.269 1.269 0 0 1 2 17.888V6.105c0-.72.584-1.304 1.304-1.304Zm13.478 8.646a1.304 1.304 0 1 0 0-2.61 1.304 1.304 0 0 0 0 2.61ZM5.912 12.14a1.304 1.304 0 1 0 2.61 0 1.304 1.304 0 0 0-2.61 0ZM12 10.837a1.304 1.304 0 1 0 0 2.608 1.304 1.304 0 0 0 0-2.608Z"
})), "0 0 24 24", "Chat");
exports.default = _default;